import { render, staticRenderFns } from "./FakeAlertCard.vue?vue&type=template&id=e83ef88e&"
import script from "./FakeAlertCard.vue?vue&type=script&lang=ts&"
export * from "./FakeAlertCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports